<template>
  <div>
    <h5 v-html="(active+1) +'.'+ data[active].examcont+'（'+ data[active].scores+'分）' "></h5>
    <div v-if="data[active].examansw[0]=='考生未答'?true:false">
      <span style="color: red">{{data[active].examansw[0]}}</span>
    </div>
    <div v-if="data[active].examansw[0]=='考生未答'?false:true">
      <div v-if="data[active].isvoice == 'Y'">
        <van-cell-group>
          <div v-for="(anitem, i) in data[active].examansw" v-if="data[active].examansw.length>0" :key="i" >
            <m-audio   :src="anitem" text="点击这里播放" :show-duration="true"  ref="player" :key="i"></m-audio>
          </div>
        </van-cell-group>
      </div>
      <div v-else-if="data[active].isvideo == 'Y'">
        <van-cell-group>
          <video controls="controls" height="150" width="300" v-if="data[active].examansw.length>0">
            <source :src="data[active].examansw[0]" type="video/mp4">
          </video>
        </van-cell-group>
      </div>
      <div v-else-if="data[active].isvideo != 'Y' && data[active].isvoice != 'Y'"  >
        <van-cell-group>
          <div v-for="(animg,k) in data[active].examansw" v-if="data[active].examansw.length>0">
            <el-image :src="animg" :preview-src-list="data[active].examansw" style="width: 100px; height: 100px"></el-image>
          </div>
        </van-cell-group>
      </div>
    </div>
    <div  style="height: 100px;width: 100%;padding: .625rem;"  ><van-field v-model="data[active].readscores"  @change="piezfchange" type="number" label="判分" /> </div>
    <div  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in data[active].examan" v-html="a.optioncontent"></a> </div>
    <div  style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="data[active].gradestand"></a> </div>
    <div style="height: 100px;width: 100%" ></div>
  </div>
</template>
<script>


export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    },
    paperId:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      maxlength: 50,
      answer: ''
    }
  },
  methods:
  {
    piezfchange()
    {
      this.$emit('piezfchange');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/teacherpage/yuejuancomm/qAndA.vue